import { Navigate, useLocation } from 'react-router';

/** Where the old Report Settings page's settings now live: Company Info (the same stored record). */
export const COMPANY_INFO_ROUTE = '/home/taxreturns/settings-reportsettings';

/**
 * APT337: the separate "Report Settings" page was removed, because every option on it is on Company Info. Its URL is
 * still served (old bookmarks, and the Resolve links the API and the statutory-database seed data still send to
 * `/home/taxreturns/report-setting`), and lands on Company Info, keeping any query string.
 */
export function ReportSettingRedirect() {
  const { search } = useLocation();
  return <Navigate to={`${COMPANY_INFO_ROUTE}${search}`} replace />;
}
